export default __webpack_public_path__ + "static/media/youtube-icon.aae34fd4.png";